interface IIsMainSelectionCappedArgs {
  isFlexServings: boolean;
  foodItemIsMain: boolean;
  numRemainingMains: number;
}

/**
 * Whether a main can no longer be added because the plan's mains are all chosen.
 *
 * Flex plans are never capped at any plan size — servings above the plan minimum are
 * the whole feature — so this turns off entirely for them rather than counting mains.
 *
 * Lives in one place because both the dish grid and the cart enforce it, and the two
 * must agree: a cart that stops accepting servings while the grid still hands them out
 * reads as a bug, and silently removes the mechanic for one-serving flex plans.
 */
export const isMainSelectionCapped = ({
  isFlexServings,
  foodItemIsMain,
  numRemainingMains,
}: IIsMainSelectionCappedArgs): boolean => !isFlexServings && foodItemIsMain && numRemainingMains <= 0;
